module.exports = __webpack_public_path__ + "img/arbitrum.1a223d40.png";